import { graphql } from 'react-relay';

export type {
    NftExhibitionEntryQuery as NftExhibitionEntryQueryType,
    NftExhibitionEntryQuery$variables,
} from './__generated__/NftExhibitionEntryQuery.graphql.ts';

export const NftExhibitionEntryQuery = graphql`
    query NftExhibitionEntryQuery(
        $pageId: String = ""
        $urlLabel: String = ""
        $isFeatured: Boolean!
        $first: Int!
        $userId: String = ""
        $fetchUser: Boolean = false
    ) {
        viewer {
            cmsExhibition: cmsNftExhibitionPage(urlLabel: $urlLabel, rootId: $pageId) {
                status
                heroBanner {
                    mobileImage {
                        url
                    }
                    bannerConfig {
                        ... on NftCmsExhibitionHtmlBannerType {
                            eyeBrow
                        }
                    }
                }
            }
            ...NftExhibitionLayout_viewer
            ...NftHeaderLayout_viewer
        }
    }
`;
